export default __webpack_public_path__ + "static/TodoAppHome-bc90b3209de6630cc343d254b58f1305.png";